import React from 'react';
import {motion} from 'framer-motion';

interface ConfirmationModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title?: string;
    message?: string | React.ReactNode;
}

const modalVariants = {
    hidden: {opacity: 0, y: -20},
    visible: {opacity: 1, y: 0, transition: {duration: 0.3}},
};

const buttonContainerVariants = {
    hidden: {opacity: 0, y: 10},
    visible: {opacity: 1, y: 0, transition: {duration: 0.3}},
};

const buttonVariants = {
    hover: {backgroundColor: '#cbd5e0'}
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({isOpen, onConfirm, onCancel, title, message}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            initial="hidden"
            animate="visible"
            variants={modalVariants}
        >
            <motion.div
                className="bg-white p-6 rounded-md shadow-lg border border-gray-200 max-w-sm w-full mx-4"
                initial={{scale: 0.8, opacity: 0}}
                animate={{scale: 1, opacity: 1}}
                exit={{scale: 0.8, opacity: 0, transition: {duration: 0.2}}}
            >
                {title && <h3 className="text-lg font-bold mb-2">{title}</h3>}
                <div className="text-sm text-gray-600">{message || "Sei sicuro di voler procedere?"}</div>
                <motion.div
                    className="mt-6 flex justify-end gap-3"
                    initial="hidden"
                    animate="visible"
                    variants={buttonContainerVariants}
                >
                    <button
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors text-sm font-medium"
                        onClick={onCancel}
                    >
                        Annulla
                    </button>
                    <button
                        className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors text-sm font-medium"
                        onClick={onConfirm}
                    >
                        Conferma
                    </button>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default ConfirmationModal;